import Clients from './Clients'
import Show from './Show'
import ClientCreateModal from './ClientCreateModal'
import Timeline from './client/Timeline'
import Details from './client/Details'
import Contacts from './client/Contacts'

export default {
    Clients,
    Show,
    Timeline,
    Details,
    ClientCreateModal,
    Contacts
}
